exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css);", ""]);

// Module
exports.push([module.id, "\n#dropzone[data-v-07e13cde] .dz-message {\n  font-weight: 700;\n  color: #acacac;\n}\n#dropzone[data-v-07e13cde] .fa-cloud-upload {\n  margin-right: 10px;\n}\n", ""]);

